import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/template.py schemas.
export interface TemplateSummary {
  template_id: number;
  name: string;
  description: string;
  subject: string;
}

export interface TemplateDetail extends TemplateSummary {
  body_html: string | null;
  body_text: string | null;
}

export interface TemplateInput {
  name: string;
  description: string;
  subject: string;
  body_html: string | null;
  body_text: string | null;
}

export async function listTemplates(): Promise<TemplateSummary[]> {
  const resp = await api.get<APIResponse<TemplateSummary[]>>("/templates/");
  return unwrap(resp.data);
}

export async function getTemplate(id: number): Promise<TemplateDetail> {
  const resp = await api.get<APIResponse<TemplateDetail>>(`/templates/${id}`);
  return unwrap(resp.data);
}

export async function createTemplate(body: TemplateInput): Promise<number> {
  const resp = await api.post<APIResponse<{ template_id: number }>>("/templates/", body);
  return unwrap(resp.data).template_id;
}

export async function updateTemplate(id: number, body: TemplateInput): Promise<void> {
  await api.put(`/templates/${id}`, body);
}

export async function deleteTemplate(id: number): Promise<void> {
  await api.delete(`/templates/${id}`);
}
